<div class="content-header">
  <div
    class="content-header-input"
    [ngClass]="customDate ? 'content-header-custom-date' : ''"
  >
    <div class="d-flex justify-space-between wp-100">
      <div
        class="d-flex wp-100 header-filters  header-count header-count-{{
          (headerList$ | async).length
        }}"
      >
        <div
          *ngFor="let item of headerList$ | async; let i = index"
          class="{{ item.name }}"
          [ngClass]="
            item.name === 'Datetime' && customDate ? 'custom-date' : ''
          "
        >
          <mat-form-field
            *ngIf="item.controlType === controlType.TextBox"
            appearance="fill"
            class="search-field"
          >
            <input
              matInput
              placeholder="Search here..."
              autocomplete="off"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchAll()"
              (keyup.enter)="onSearch()"
            />
            <button mat-button class="search-button" (click)="onSearch()">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
          <div
            *ngIf="item.controlType === controlType.DateTimePicker"
            class="year-picker d-flex align-items-center fw-bold mr-10"
          >
            <span>Period:</span>
            <app-custom-year-picker
              [moduleId]="moduleId"
              (triggerDateChange)="triggerDateChange($event)"
            ></app-custom-year-picker>
          </div>
          <div
            class="content-right-button d-flex align-items-center fw-bold"
            *ngIf="item.controlType === controlType.Dropdown"
          >
            <span>Fund:</span>
            <mat-form-field class="w-200">
              <mat-select
                panelClass="mat-select-position"
                [disableOptionCentering]="true"
                [(value)]="
                  item.name === HeaderFilters.Module
                    ? commonService.defaultHeaderGuidValue
                    : defaultValue[i].id
                "
                (selectionChange)="
                  onDropdownChange(item.name, $event.value, false)
                "
              >
                <mat-option
                  *ngFor="let cl of item.value"
                  [value]="cl.id"
                  title="{{ cl.name }}"
                >
                  {{ cl.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="toolbar">
      <button mat-button [matMenuTriggerFor]="menu" disableRipple>
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu
        #menu="matMenu"
        class="action-menu more-menu"
        xPosition="before"
      >
        <button
          mat-menu-item
          (click)="export(exportType.PDF, false)"
          disableRipple
        >
          <mat-icon fontSet="material-icons-outlined">picture_as_pdf</mat-icon>
          Export As PDF
        </button>
        <button
          mat-menu-item
          (click)="export(exportType.Excel, false)"
          disableRipple
        >
          <mat-icon>border_all</mat-icon>Export to excel
        </button>
        <button
          mat-menu-item
          (click)="export(exportType.CSV, false)"
          disableRipple
        >
          <mat-icon fontSet="material-icons-outlined">description</mat-icon
          >Export to CSV
        </button>
      </mat-menu>
    </div>
  </div>
</div>
